module.exports = __webpack_public_path__ + "assets/media/2.3b5898d3.wav";